import { chartColors } from '../../../Common/Charts/enums/chart-colors.enum';
import { UserAppPreferenceChartColors } from '../models/user-app-preferences-chart-colors.model';

export const defaultChartColorsNeptuneOnly: UserAppPreferenceChartColors = {
    generalColors: {
        color1: chartColors.agprBlue,
        color2: chartColors.agprPurple,
        color3: chartColors.agprLightBlue,
        color4: chartColors.agprOrange,
        color5: chartColors.agprYellow,
        color6: chartColors.agprLightGreen,
        color7: chartColors.agprGreen,
        color8: chartColors.agprTeal,
        color9: chartColors.agprMediumBlue,
        color10: chartColors.agprDarkPurple,
    },
    mediaTypeColors: {
        onlineNews: chartColors.agprOnline,
        print: chartColors.agprPrint,
        pressRelease: chartColors.agprPressRelease,
        blogs: chartColors.agprBlog,
        TV: chartColors.agprTelevision,
        radio: chartColors.agprRadio,
        podcast: chartColors.agprPodcast,
        facebook: chartColors.agprFacebook,
        twitter: chartColors.agprX,
        reddit: chartColors.agprReddit,
        youtube: chartColors.agprYoutube,
        instagram: chartColors.agprInstagram,
        tiktok: chartColors.agprTiktok,
        snapchat: chartColors.agprSnapchat,
        threads: chartColors.agprThreads,
        linkedin: chartColors.agprLinkedIn,
        wechat: chartColors.agprWechat,
        sinaWeibo: chartColors.agprSinaWeibo,
        twitch: chartColors.agprTwitch,
        pinterest: chartColors.agprPinterest,
        tumblr: chartColors.agprTumblr,
        telegram: chartColors.agprTelegram,
        whatsapp: chartColors.agprWhatsapp,
        vk: chartColors.agprVK,
        other: chartColors.agprOther,
        magazine: chartColors.agprMagazine,
        bluesky: chartColors.agprBluesky,

    },
    socialNetworkColors: {
        facebook: chartColors.agprFacebook,
        twitter: chartColors.agprX,
        reddit: chartColors.agprReddit,
        youtube: chartColors.agprYoutube,
        instagram: chartColors.agprInstagram,
        tiktok: chartColors.agprTiktok,
        linkedin: chartColors.agprLinkedIn,
        bluesky: chartColors.agprBluesky,
    },
    sentimentColors: {
        positive: chartColors.agprPositive,
        negative: chartColors.agprNegative,
        neutral: chartColors.agprNeutral,
        notAvailable: chartColors.agprNotAvailable,
    },
    gaugeColors: {
        color1: chartColors.agprPositive,
        color2: chartColors.agprNeutral,
        color3: chartColors.agprNegative,
        color4: chartColors.agprPurple
    },
    barColors: {
        barColor: chartColors.agprBlue,
        previousBarColor: chartColors.agprLighterMediumGrey
    },
    otherColors: {
        uptrendColor: chartColors.agprPositive,
        downtrendColor: chartColors.agprNegative,
        bigNumberColor: chartColors.agprText,
        textColor: chartColors.agprText,
        volume: chartColors.agprVolume,
        volumePrevious: chartColors.agprVolumePrevious,
        engagements: chartColors.agprEngagements,
        engagementPrevious: chartColors.agprEngagementsPrevious,
        impressions: chartColors.agprImpressions,
        impressionsPrevious: chartColors.agprImpressionsPrevious
    }
};
